
interface DataTableProps {
  data: any[];
}

export default function DataTable({ data }: DataTableProps) {
  if (!data || data.length === 0) {
    return (
      <div className="p-8 text-center">
        <i className="ri-file-list-line text-4xl text-gray-400 mb-2"></i>
        <p className="text-gray-500">No payroll data available</p>
      </div>
    );
  }

  const formatCurrency = (value: any) => {
    if (value === null || value === undefined || value === '') return '$0.00';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/[$,]/g, '')) : value;
    return isNaN(numValue) ? '$0.00' : `$${numValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatNumber = (value: any) => {
    if (value === null || value === undefined || value === '') return '0';
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    return isNaN(numValue) ? '0' : numValue.toLocaleString('en-US');
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              Agent
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              Aux Fees
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              Aux Pay
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              BD Collected
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              BF
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              BF Pay
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              Chargeback
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              Hours
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              Hourly Pay
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              POL
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              POL Pay
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              RS
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
              RS Pay
            </th>
            <th className="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap bg-green-50">
              Total Pay
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data.map((row, index) => {
            const isTotal = row.agent?.toLowerCase() === 'total';
            return (
              <tr
                key={index}
                className={`hover:bg-gray-50 transition-colors ${isTotal ? 'bg-blue-50 font-semibold' : ''}`}
              >
                <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                  {row.agent || 'N/A'}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.aux_fees)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.aux_pay)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.bd_collected)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.bf)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.bf_pay)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.chargeback)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatNumber(row.hours)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.hourly_pay)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatNumber(row.pol)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.pol_pay)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatNumber(row.rs)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap">
                  {formatCurrency(row.rs_pay)}
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right whitespace-nowrap bg-green-50 font-semibold">
                  {formatCurrency(row.total_pay)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
